import { render, staticRenderFns } from "./league.vue?vue&type=template&id=41e03488&scoped=true"
import script from "./league.vue?vue&type=script&lang=js"
export * from "./league.vue?vue&type=script&lang=js"
import style0 from "./league.vue?vue&type=style&index=0&id=41e03488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e03488",
  null
  
)

export default component.exports